import React, { useEffect } from "react";
import { Button,  Modal} from "react-bootstrap";

const StatusModalBox = ({ modalStatus, onCloseModal, statusTypes, onChangeTempStatus, onSubmitHandler, currentStatus }) => {
    return (
        <Modal
            show={modalStatus}
            backdrop="static"
            keyboard={false}
            centered
            className="enStatusListModal"
            size="md"
            onHide={() => onCloseModal()}
        >
            <Modal.Header className="border-0" closeButton>
                <Modal.Title className="f24_700_HelveticaNeue">
                    Issue/Suggestion Status
          </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="pb-4 f16-500">
                    Select one relevant option from below
          </div>
                <ul type="none" className="enStatusList">
                    {statusTypes.map((status, index) => (
                        <li
                            onClick={() => onChangeTempStatus(status.status)}
                            key={index}
                            className={`${currentStatus === status.status ? "active" : ""}`}
                        >
                            {status.name}
                        </li>
                    ))}
                </ul>
                <div className="py-4 d-flex align-items-center">
                    <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 btn150px"
                        onClick={onCloseModal}
                    >
                        Cancel
            </Button>
                    <Button
                        variant="danger"
                        onClick={() => onSubmitHandler()}
                        className={`btn-lg px-5 btn150px `}
                    >
                        Confirm
            </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
};


export default StatusModalBox;